module.exports = __webpack_public_path__ + "bb3e6ccf6aaef64c6ec36ed7841c7e57.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/LabilGrotesk-Medium.woff
// module id = 31
// module chunks = 0 1